import styled from '@emotion/styled';

import { breakpoints, fontWeight } from '~/src/styles';

export const Title = styled.h1`
  font-size: 22px;
  font-weight: ${fontWeight.semiBold};
  line-height: 30px;
  letter-spacing: 0.03em;
  text-align: left;
  color: white;

  ${breakpoints.minDesktop} {
    font-size: 45px;
    line-height: 65px;
    letter-spacing: 0.03em;
    text-align: left;
  }
`;
export const Container = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
`;
export const Text = styled.div`
  font-size: 16px;
  font-weight: ${fontWeight.regular};
  line-height: 25px;
  letter-spacing: 0.03em;
  text-align: left;
  color: white;
`;
